const LOCALE_COOKIE_MAP = {
  co: 'es',
  mx: 'es',
  la: 'es',
}

/**
 * Sets the hmLangCookie with the mapped locale value for Cookie Notice compatibility.
 * Spanish variants (co, mx, la) are mapped to 'es'.
 * Other locales are set as-is.
 */
export default function ({ app }) {
  const locale = app.i18n?.locale
  if (!locale || !app.$cookies) return

  const mapped = LOCALE_COOKIE_MAP[locale] || locale
  const domain = process.env.ENVIROMENT === 'staging' ? '.buildstaging.com' : '.hotmart.com'

  app.$cookies.set('hmLangCookie', mapped, {
    path: '/',
    domain,
    sameSite: 'lax',
  })
}
